module.exports = __webpack_public_path__ + "img/banner_bgimg.9a08993e.png";